<template>
    <div id="ForestryFirefighting">
    <view1/>
    <view2/>
    <view3/>
    <view4/>
    <view5/>
    <view6/>
    </div>

</template>
<script>
    export default {
        name: 'ForestryFirefighting',
        components: {
        view1: () => import('@/views/ForestryFirefighting/view1.vue'),
        view2: () => import('@/views/ForestryFirefighting/view2.vue'),
        view3: () => import('@/views/ForestryFirefighting/view3.vue'),
        view4: () => import('@/views/ForestryFirefighting/view4.vue'),
        view5: () => import('@/views/ForestryFirefighting/view5.vue'),
        view6: () => import('@/views/ForestryFirefighting/view6.vue')
        }
    }
</script>
<style scoped>
</style>